module.exports = __webpack_public_path__ + "static/marriage-preparation-9f86dc807d455f3fd48007493d5dfe3a.jpg";